import React from 'react';
import {MasterLayout} from 'components/layouts';
import {ComplaintDetailContainer} from 'components/users';
import MemberZone from './MemberZone.jsx'
import title from 'constants/TitlePages.js';

class ComplaintDetail extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  componentDidMount() {
    document.title = title.ComplaintDetail;
  }

  render() {
    return (
      <MasterLayout>
        <ComplaintDetailContainer/>
      </MasterLayout>
    );
  }
}

export default MemberZone(ComplaintDetail);



// WEBPACK FOOTER //
// ./pages/users/ComplaintDetail.jsx